import { render, staticRenderFns } from "./NftSwapItem.vue?vue&type=template&id=71bdebc6&scoped=true&"
import script from "./NftSwapItem.vue?vue&type=script&lang=ts&"
export * from "./NftSwapItem.vue?vue&type=script&lang=ts&"
import style0 from "./NftSwapItem.vue?vue&type=style&index=0&id=71bdebc6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdebc6",
  null
  
)

export default component.exports